var map = {
	"./al-midrar": 42367,
	"./al-midrar.js": 42367,
	"./anees_hussain": 72750,
	"./anees_hussain.js": 72750,
	"./astc": 48707,
	"./astc.js": 48707,
	"./default": 55829,
	"./default.js": 55829,
	"./edcentra": 95188,
	"./edcentra.js": 95188
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47995;